import { render, staticRenderFns } from "./sys_module_roles.vue?vue&type=template&id=11663d52&scoped=true"
import script from "./sys_module_roles.vue?vue&type=script&lang=js"
export * from "./sys_module_roles.vue?vue&type=script&lang=js"
import style0 from "./sys_module_roles.vue?vue&type=style&index=0&id=11663d52&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11663d52",
  null
  
)

export default component.exports